import { Modal } from "react-bootstrap";
import { useState } from "react";
import CustomButton from "../kits/custom-button/CustomButton";
import toast from "react-hot-toast";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import ProductImagePicker from "../adminPanel/adminPanelFields/ProductImagePicker";
import useAxios from "../../services/useAxios";
export default function EditSingleProduct({ product, updater1, setUpdater1 }) {
  console.log(product);
  const [editModalShow, setEditModalShow] = useState(false);
  const { loading, execute: editProduct } = useAxios(
    "supplier/edit_product_supplier"
  );
  const [selectedProduct, setSelectedProduct] = useState({
    ...product,
    avb_product: {
      ...product?.avb_product,
      priceWithDiscount:
        product?.avb_product?.price - product?.avb_product?.discount,
      supplier_cover_img: product?.cover2,
      product_cover_img: product?.cover1,
    },
  });

  // const [selectedOption, setSelectedOption] = useState(
  //     JSON.parse(product?.avb_product?.available_order_option_ids)
  //   );
  console.log(selectedProduct);
  const [imgSupplier, setImgSupplier] = useState({});

  function productImageHandler(names, value) {
    setSelectedProduct((prev) => {
      let temp = { ...prev.avb_product };
      temp = { ...temp, [names]: URL.createObjectURL(value) };
      return { ...selectedProduct, avb_product: temp };
    });
  }
  function sendImage(value) {
    setImgSupplier(value);
  }
  function inputChangeHandler(event: Event, isNumber: boolean = false) {
    let value: string = event.target.value,
      name: string = event.target.name;
    try {
      if (isNumber) {
        value = removeCommas(value);
        if (isNaN(value)) {
          throw new Error("لطفا عدد را به درستی وارد نمایید.");
        }
        value = +value;
      }
      let tName = name.toLowerCase();

      // if (tName === "pricewithdiscount" && selectedProduct?.avb_product?.price < value)
      //   throw new Error("تخفیف نمیتواند از قیمت بیشتر باشد.");
      // if (tName === "price" && selectedProduct?.avb_product?.priceWithDiscount > value)
      //   throw new Error("قیمت نمیتواند از تخفیف کمتر باشد.");

      if (
        tName === "min_order_count" &&
        selectedProduct?.avb_product?.total_inventory_count < value
      )
        throw new Error("حداقل سفارش نمیتواند از موجودی بیشتر باشد.");
      if (
        tName === "total_inventory_count" &&
        selectedProduct?.avb_product?.min_order_count > value
      )
        throw new Error("موجودی نمیتواند از حداقل سفارش کمتر باشد.");

      if (
        tName === "weight_from" &&
        selectedProduct?.avb_product?.weight_to < value
      )
        throw new Error("حداقل وزن نمیتواند از حداکثر وزن بیشتر باشد.");
      if (
        tName === "weight_to" &&
        value != 0 &&
        selectedProduct?.avb_product?.weight_from > value
      )
        throw new Error("حداکثر وزن نمیتواند از حداقل وزن کمتر باشد.");

      setSelectedProduct((prev) => {
        let temp = { ...prev.avb_product };
        temp = { ...temp, [name]: value };
        return { ...selectedProduct, avb_product: temp };
      });
    } catch (ex) {
      toast.error(ex.message);
    }
  }

  //   function checkBoxHandler(index, event: Event | undefined) {
  //     if (event) {
  //       let price = event.target.value;
  //       if (!isNaN(price)) {
  //         setSelectedOption(prev =>
  //           prev.map((v, i) => {
  //             if (i == index) return { ...v, default_price: +price };
  //             return v;
  //           })
  //         );
  //       } else {
  //         toast.error("لطفا عدد را به درستی وارد نمایید.");
  //       }
  //     } else {
  //       setSelectedOption(prev =>
  //         prev.map((v, i) => {
  //           if (i == index) return { ...v, status: !v.status };
  //           return v;
  //         })
  //       );
  //     }
  //   }

  //   function checkBoxHandler1(index, event: Event | undefined) {
  //     if (event) {
  //       let time = event.target.value;
  //       if (!isNaN(time)) {
  //         setSelectedOption(prev =>
  //           prev.map((v, i) => {
  //             if (i == index) return { ...v, default_need_time: +time * 60 };
  //             return v;
  //           })
  //         );
  //       } else {
  //         toast.error("لطفا عدد را به درستی وارد نمایید.");
  //       }
  //     } else {
  //       setSelectedOption(prev =>
  //         prev.map((v, i) => {
  //           if (i == index) return { ...v, status: !v.status };
  //           return v;
  //         })
  //       );
  //     }
  //   }
  const [validationProduct, setValidationProduct] = useState({
    price: true,
    weightFrom: true,
    weightTo: true,
    productId: true,
    inventory: true,
    // checkWeight: true
  });
  const validation = () => {
    let isValid = true;
    if (
      selectedProduct?.avb_product?.price <
      selectedProduct?.avb_product?.priceWithDiscount
    ) {
      isValid = false;
      toast.error("تخفیف نمیتواند از قیمت بیشتر باشد.");
    }

    if (selectedProduct?.avb_product?.price == "") {
      setValidationProduct((prev) => {
        return { ...prev, price: false };
      });
      isValid = false;
    } else {
      setValidationProduct((prev) => {
        return { ...prev, price: true };
      });
    }

    if (selectedProduct?.avb_product?.total_inventory_count == "") {
      setValidationProduct((prev) => {
        return { ...prev, inventory: false };
      });
      isValid = false;
    } else {
      setValidationProduct((prev) => {
        return { ...prev, inventory: true };
      });
    }

    return isValid;
  };

  function submitForm() {
    editProduct({
      avb_pid: selectedProduct.avb_product.avb_product_for_order__id,

      price: selectedProduct.avb_product.price,
      discount:
        selectedProduct.avb_product.price -
        selectedProduct.avb_product.priceWithDiscount,

      img_cover_files_id: imgSupplier,

      new_inventory: selectedProduct.avb_product.total_inventory_count,
      min_order_count: selectedProduct.avb_product.min_order_count,
      weight_from: selectedProduct.avb_product.weight_from,
      weight_to: selectedProduct.avb_product.weight_to,
      //   selected_aoos: JSON.stringify(selectedOption)
      selected_aoos: "",
    }).then((data) => {
      if (data.status == 1) {
        setUpdater1(!updater1);
        setEditModalShow(false);
        toast.success("محصول با موفقیت ویرایش شد.");
        document.querySelector("#editProductModal .btn-close").click();
      } else {
        toast.error("مشکلی در ویرایش محصول به وجود آمد");
        document.querySelector("#editProductBtn").disabled = false;
      }
    });
  }
  console.log("sss", imgSupplier.name, Object.keys(imgSupplier).length);
  return (
    <div>
      
      <CustomButton
        className="w-100"
        buttonStyle="primary"
        size="medium"
        // state={shopStatus ? "default" : "disable"}
        onClick={() => {
          setEditModalShow(true);
        }}
        disabledOnClick={() => {}}
      >
        ویرایش
      </CustomButton>
      <Modal
        show={editModalShow}
        onHide={() => {
          setEditModalShow(false);
        }}
      >
        <Modal.Header closeButton className="txt-t1-m">
          ویرایش{" "}
        </Modal.Header>
        <Modal.Body>
          {" "}
          <div className="edit-product">
            <form className="txt-t1-m">
              <div>
                {selectedProduct && (
                  <div className="d-flex justify-content-center">
                    <ProductImagePicker
                      className="mx-3"
                      productImageHandler={(x, e) => {
                        productImageHandler("supplier_cover_img", e);
                        sendImage(e);
                      }}
                      index={0}
                      src={
                        imgSupplier?.name != undefined
                          ? URL.createObjectURL(imgSupplier)
                          : `https://sabadi.ir/api/${selectedProduct?.avb_product?.supplier_cover_img}`
                      }
                      type={true}
                    />

                    <span style={{ width: "20px" }}></span>
                    {selectedProduct?.avb_product?.product_cover_img && (
                      <ProductImagePicker
                        src={`https://sabadi.ir/api/${selectedProduct?.avb_product?.product_cover_img}`}
                        index={1}
                        type={false}
                        productImageHandler={() => {}}
                      />
                    )}
                  </div>
                )}
              </div>
              <div>
                <div class=" form-floating my-4 ">
                  <input
                    type="text"
                    class="form-control df-input"
                    id="product-title"
                    placeholder="title"
                    name="title"
                    value={selectedProduct?.title}
                    readOnly
                    disabled
                  />
                  <p
                    className={`text-danger fs-12 ${
                      validationProduct.title == false ? "d-block" : "d-none"
                    }`}
                  >
                    این فیلد نمی تواند خالی باشد
                  </p>
                  <label for="product-title">عنوان کالا</label>
                </div>
                <div className="d-flex justify-content-between align-items-center flex-wrap pricestyle">
                  <div class=" form-floating mb-4 w-48">
                    <input
                      type="text"
                      class="form-control df-input"
                      id="product-price"
                      placeholder="price"
                      name="price"
                      value={addCommas(selectedProduct?.avb_product?.price)}
                      onChange={(e) => {
                        inputChangeHandler(e, true);
                      }}
                    />
                    <p
                      className={`text-danger fs-12 ${
                        validationProduct.price == false ? "d-block" : "d-none"
                      }`}
                    >
                      این فیلد نمی تواند خالی باشد
                    </p>
                    <label for="product-price">قیمت(تومان)</label>
                  </div>
                  <div class="form-floating mb-4 w-48">
                    <input
                      type="text"
                      class="form-control df-input"
                      id="product-discount"
                      placeholder="discount"
                      name="priceWithDiscount"
                      value={addCommas(
                        selectedProduct?.avb_product?.priceWithDiscount
                      )}
                      onChange={(e) => {
                        inputChangeHandler(e, true);
                      }}
                    />

                    <label for="product-discount">قیمت با تخفیف (تومان)</label>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center flex-wrap pricestyle">
                  <div class="form-floating mb-4 w-48">
                    <input
                      type="text"
                      class="form-control df-input"
                      id="product-total_inventory_count"
                      placeholder="total_inventory_count"
                      name="total_inventory_count"
                      value={
                        selectedProduct?.avb_product?.total_inventory_count
                      }
                      onChange={(e) => inputChangeHandler(e, true)}
                    />
                    <p
                      className={`text-danger fs-12 ${
                        validationProduct.inventory == false
                          ? "d-block"
                          : "d-none"
                      }`}
                    >
                      این فیلد نمی تواند خالی باشد
                    </p>
                    <label for="product-total_inventory_count">موجودی </label>
                  </div>

                  <div class="form-floating mb-4 w-48">
                    <input
                      type="text"
                      class="form-control df-input"
                      id="product-leastOrder"
                      placeholder="leastOrder"
                      name="min_order_count"
                      value={selectedProduct?.avb_product?.min_order_count}
                      onChange={(e) => inputChangeHandler(e, true)}
                    />
                    <label for="product-leastOrder">حداقل سفارش</label>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-baseline flex-wrap pricestyle ">
                  <div class="form-floating mb-4 w-48">
                    <input
                      type="text"
                      class="form-control df-input"
                      id="product-weightFrom"
                      placeholder="weightFrom"
                      name="weight_from"
                      value={addCommas(
                        selectedProduct?.avb_product?.weight_from
                      )}
                      onChange={(e) => inputChangeHandler(e, true)}
                    />

                    <label for="product-weightFrom">حداقل وزن (گرم)</label>
                  </div>
                  <div class="form-floating mb-4 w-48">
                    <input
                      type="text"
                      class="form-control df-input"
                      id="product-weightTo"
                      placeholder="weightTo"
                      name="weight_to"
                      value={addCommas(selectedProduct?.avb_product?.weight_to)}
                      onChange={(e) => inputChangeHandler(e, true)}
                    />

                    <label for="product-weightTo">حداکثر وزن (گرم)</label>
                  </div>
                </div>

                {/* <div className="product-options-container">
                    {selectedOption.map((value1, index) => {
                      return (
                        <div
                          key={`product-option-${index}`}
                          className="product-option flex-wrap"
                        >
                          <div className="d-flex">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked={value1.status}
                                key={index}
                                // onChange={() =>
                                //   setSelectedOption(prev => {
                                //     let temp = [...prev];
                                //     temp[index].status = !selectedOption[index]
                                //       .status;
                                //     return temp;
                                //   })
                                // }
                              />
                              <span class="slider round"></span>
                            </label>
                            <div className="mx-3">{value1.title}</div>
                          </div>
                          {value1.status && (
                            <div className="d-flex align-items-center  mt-1">
                              <input
                                type="text"
                                className="form-control product-option-input"
                                // value={selectedOption[index].default_price}
                                // onChange={e => {
                                //   checkBoxHandler(index, e);

                                // }}
                              />
                              <span>تومان</span>
                              <input
                                type="text"
                                className="form-control product-option-input"
                                style={{ width: "50px" }}
                                // value={
                                //   selectedOption[index].default_need_time / 60
                                // }
                                // onChange={e => checkBoxHandler1(index, e)}
                              />
                              <span>دقیقه</span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div> */}
                {/* ) */}
                {/* } */}
              </div>
              <div className="w-100 d-flex justify-content-end">
                <CustomButton
                  buttonStyle="primary"
                  size="medium"
                  className=" px-5 py-2 submit-btn"
                  id="editProductBtn"
                  onClick={(e) => {
                    console.log("sSss", setUpdater1);

                    e.preventDefault();
                    if (validation()) {
                      submitForm();
                    }
                  }}
                >
                  ویرایش کالا
                </CustomButton>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
